import { LegalLayout } from "./components/legalLayout";
import { CANCELLATION } from "./content/cancellation";

/** /politica-de-cancelamento — teste grátis, cancelamento, dados e número de WhatsApp. */
export const PoliticaDeCancelamento = () => (
  <LegalLayout document={CANCELLATION} />
);
